/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import HelpIcon from '@material-ui/icons/Help';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  icon: {
    cursor: 'default',
    color: theme.palette.customHelpIcon,
  },
}));
const CustomHelpIcon = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const { children } = props;
  return (
    <HelpIcon className={classes.icon} ref={ref} {...props} tabIndex={-1}>
      {children}
    </HelpIcon>
  );
});
export default CustomHelpIcon;
